import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useSMP() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/smp/")
    .then((res: SuccessFetch<{
      payload: {
        smp_id: number
        smp_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.smp_name, value: item.smp_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/smp/").then((res: SuccessFetch<{
      payload: {
        smp_id: number
        smp_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.smp_name,
          value: item.smp_id?.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}